import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SitemapHelper from '../helpers/sitemap-helper';
import { isProduction } from '../helpers/environment-helper';

// Hook to manage sitemap generation
export const useSitemap = () => {
  const [sitemapInfo, setSitemapInfo] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);

  const { categories } = useSelector((state) => state.category);

  // Mock coaches data - gerçek uygulamada API'den gelecek
  const coaches = [
    {
      id: '123e4567-e89b-12d3-a456-426614174000',
      firstName: 'Ayşe',
      lastName: 'Yılmaz',
      updatedAt: '2024-01-15T10:30:00Z',
    },
    {
      id: '987fcdeb-51f2-43a8-b6d9-426614174111',
      firstName: 'Mehmet',
      lastName: 'Kaya',
      updatedAt: '2024-01-20T14:20:00Z',
    },
  ];

  // Generate sitemap info when data changes
  useEffect(() => {
    if (isProduction() && categories && categories.length > 0) {
      const info = SitemapHelper.getSitemapInfo(categories, coaches);
      setSitemapInfo(info);

      // Auto-generate sitemap in background (optional)
      generateSitemap();
    }
  }, [categories]);

  const generateSitemap = async () => {
    if (!isProduction()) {
      console.log('Sitemap generation skipped - not in production');
      return null;
    }

    setIsGenerating(true);
    try {
      const content = SitemapHelper.generateSitemap(categories, coaches);
      console.log('Sitemap generated automatically');
      return content;
    } catch (error) {
      console.error('Error generating sitemap:', error);
      return null;
    } finally {
      setIsGenerating(false);
    }
  };

  const downloadSitemap = async () => {
    const content = await generateSitemap();
    if (!content) return;

    const blob = new Blob([content], { type: 'application/xml' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'sitemap.xml';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return {
    sitemapInfo,
    isGenerating,
    generateSitemap,
    downloadSitemap,
    isProduction: isProduction(),
  };
};
